var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row no-gutters h-100"},[_c('div',{staticClass:"col-sm-12 col-md-5 col-lg-3 no-flow"},[_c('BQdtCard',{attrs:{"name":"globalComparisons","type":"header-item"}})],1),_c('div',{staticClass:"col-sm-9 col-md-7 col-lg-6"},[_c('BQdtCard',{attrs:{"name":"globalVSYears","type":"header-item"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }